/* This is the EMIS School Area components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 43px"
        width="490px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទ
            </td>
            <td class="data-row">បណ្ដោយ</td>
            <td class="data-row">ទទឹង</td>
            <td class="data-row">(គិតជា ម<sup>២</sup>)</td>
          </tr>
          <tr v-for="(value, row) in e1.length - last_row" :key="row">
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ e1[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              :class="[!e1OnOff[row][col] ? 'row-data-gray' : 'row-data']"
            >
              <numberinput
                v-model="data[row].dt[col]"
                :disabled="!e1OnOff[row][col]"
                class="number"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { e1, e1OnOff } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  /* last_row control hide/show area for gardeninig */
  props: ["data", "last_row", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      e1: e1,
      e1OnOff: e1OnOff,
    };
  },
};
</script>
<style scoped>
.number {
  width: 60px;
  text-align: center;
}
.row-data {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
</style>